import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, createTextVNode as _createTextVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-535c81f5"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["onClick"]

import { UsuarioEloTablaClasificacion } from "@/interfaces/Elo";
import { ref } from "vue";
import { useRouter } from "vue-router";
import {
  VDataTable,
  VCard,
  VCardTitle,
  VDivider,
  VTextField,
} from "vuetify/components";


export default /*#__PURE__*/_defineComponent({
  __name: 'TablaClasificacionElo',
  props: {
    items: {}
  },
  setup(__props: any) {



const search = ref<string>("");
const router = useRouter();

const headers = [
  { title: "#", key: "clasificacion" },
  { title: "Nick", key: "nick" },
  { title: "ELO", key: "elo" },
  { title: "V", key: "ganadas" },
  { title: "E", key: "empatadas" },
  { title: "D", key: "perdidas" },
  { title: "Jugadas", key: "partidas" },
];

const goToUserDetail = (idUsuario: number) => {
  router.push({ name: "detalle-jugador", params: { idUsuario: idUsuario } });
};

return (_ctx: any,_cache: any) => {
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_chip = _resolveComponent("v-chip")!

  return (_openBlock(), _createBlock(_unref(VCard), { flat: "" }, {
    default: _withCtx(() => [
      _createVNode(_unref(VCardTitle), { class: "d-flex align-center pe-2" }, {
        default: _withCtx(() => [
          _createTextVNode("Individual "),
          _createVNode(_component_v_spacer),
          _createVNode(_unref(VTextField), {
            modelValue: search.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((search).value = $event)),
            density: "compact",
            label: "Buscar",
            "prepend-inner-icon": "mdi-magnify",
            variant: "solo-filled",
            flat: "",
            "hide-details": "",
            "single-line": ""
          }, null, 8, ["modelValue"])
        ]),
        _: 1
      }),
      _createVNode(_unref(VDivider)),
      _createVNode(_unref(VDivider)),
      _createVNode(_unref(VDataTable), {
        search: search.value,
        "onUpdate:search": _cache[1] || (_cache[1] = ($event: any) => ((search).value = $event)),
        items: _ctx.items,
        headers: headers,
        class: "custom-table",
        "item-key": "nick"
      }, {
        item: _withCtx(({ item }) => [
          _createElementVNode("tr", {
            onClick: ($event: any) => (goToUserDetail(item.idUsuario)),
            class: "clickable-row"
          }, [
            _createElementVNode("td", null, _toDisplayString(item.clasificacion), 1),
            _createElementVNode("td", null, _toDisplayString(item.nick), 1),
            _createElementVNode("td", null, [
              _createVNode(_component_v_chip, {
                color: "blue",
                dark: ""
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(item.elo), 1)
                ]),
                _: 2
              }, 1024)
            ]),
            _createElementVNode("td", null, [
              _createVNode(_component_v_chip, {
                color: "green",
                dark: ""
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(item.ganadas), 1)
                ]),
                _: 2
              }, 1024)
            ]),
            _createElementVNode("td", null, [
              _createVNode(_component_v_chip, {
                color: "yellow",
                dark: ""
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(item.empatadas), 1)
                ]),
                _: 2
              }, 1024)
            ]),
            _createElementVNode("td", null, [
              _createVNode(_component_v_chip, {
                color: "red",
                dark: ""
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(item.perdidas), 1)
                ]),
                _: 2
              }, 1024)
            ]),
            _createElementVNode("td", null, _toDisplayString(item.partidas), 1)
          ], 8, _hoisted_1)
        ]),
        _: 1
      }, 8, ["search", "items"])
    ]),
    _: 1
  }))
}
}

})